import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { UserRoleEnum } from '@app/core/enums/user-role.enum';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { UserStorageService } from '@app/core/services/user-storage.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  isLoggedIn$!: Observable<boolean>;
  items!: MenuItem[];
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter();
  constructor(
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private userStorageService: UserStorageService
  ) {}

  ngOnInit() {
    const currentUser = this.userStorageService.currentUser;
    this.isLoggedIn$ = this.authenticationService.isLoggedIn;
      this.items = [{
          label: $localize `Home`,
          routerLink: '/dashboard',
          icon: 'pi pi-fw pi-home'
      },
      {
          label: $localize `Archive`,
          routerLink: '/archive',
          icon: 'pi pi-fw pi-briefcase'
      },
      {
          label: $localize `Network`,
          routerLink: '/station/network',
          icon: 'pi pi-fw pi-sitemap'
      },
    ];

    if (currentUser?.role === UserRoleEnum.ADMIN) {
      this.items.push({
          label: $localize `Layout`,
          routerLink: '/layout',
          icon: 'pi pi-fw pi-table'
      });

      this.items.push({
          label: $localize `Users`,
          routerLink: '/user',
          icon: 'pi pi-fw pi-users'
      });

      this.items.push({
          label: $localize `Stations`,
          icon: 'pi pi-fw pi-star',
          items: [
            {
                label: 'RELAY',
                routerLink: '/station/relay',
                icon: 'pi pi-fw pi-star'
            },
            {
                label: 'BAK',
                routerLink: '/station/bak',
                icon: 'pi pi-fw pi-star'
            },
            {
                label: 'ESA',
                routerLink: '/station/esa',
                icon: 'pi pi-fw pi-star'
            }
          ]
      });

      this.items.push({
          label: $localize `Admin`,
          icon: 'pi pi-fw pi-cog',
          items: [
            {
                label: $localize `Main`,
                routerLink: '/admin',
                icon: 'pi pi-fw pi-eye'
            },
            {
                label: $localize `Hooks`,
                routerLink: '/admin/hook',
                icon: 'pi pi-fw pi-external-link'
            }
          ]
      });
    }
  }
}
